import path from '@/admin/assets/svg/path.svg';
import pathActive from '@/admin/assets/svg/pathActive.svg';
import dropDown from '@/admin/assets/svg/dropDown.svg';
import dropDownV from '@/admin/assets/svg/dropDownV.svg';
import dropDownBlueV from '@/admin/assets/svg/dropDownBlueV.svg';
import VIcon from '@/admin/assets/svg/V.svg';
import Search from '@/admin/assets/svg/search.svg';
import ArrowLeft from '@/admin/assets/svg/arrowLeft.svg';
import separator from '@/admin/assets/svg/separator.svg';
import toggleOff from '@/admin/assets/svg/toggleOff.svg';
import toggleOn from '@/admin/assets/svg/toggleOn.svg';
import logo from '@/admin/assets/svg/logo.svg';
import portuguese from '@/admin/assets/svg/Portuguese.svg';
import date from '@/admin/assets/svg/date.svg';
import leftArrow from '@/admin/assets/svg/leftArrow.svg';
import arrowRight from '@/admin/assets/svg/rightArrow.svg';
import filter from '@/admin/assets/svg/filter.svg';
import arrowUp from '@/admin/assets/svg/arrowUp.svg';
import arrowDown from '@/admin/assets/svg/arrowDown.svg';
import userAvatar from '@/admin/assets/svg/userAvatar.svg';
import logoIcon from '@/admin/assets/svg/logotext.svg';
import districts from '@/admin/assets/svg/districts.svg';
import schools from '@/admin/assets/svg/schools.svg';
import history from '@/admin/assets/svg/history.svg';
import userManagement from '@/admin/assets/svg/userManagement.svg';
import deals from '@/admin/assets/svg/deal.svg';
import x from '@/admin/assets/svg/X.svg';
import close from '@/admin/assets/svg/close.svg';
import arrowUpActive from '@/admin/assets/svg/up.svg';
import arrowDownActive from '@/admin/assets/svg/down.svg';
import pencil from '@/admin/assets/svg/pencil.svg';
import deleteIcon from '@/admin/assets/svg/trash.svg';
import checkCircle from '@/admin/assets/svg/checkCircle.svg';
import cloudUpload from '@/admin/assets/svg/cloudUpload.svg';
import download from '@/admin/assets/svg/download.svg';
import whiteV from '@/admin/assets/svg/whiteV.svg';
import classReport from '@/admin/assets/svg/report.svg';
import diamond from '@/admin/assets/svg/diamond.svg';
import star from '@/admin/assets/svg/star.svg';
import avg from '@/admin/assets/svg/avg.svg';
import Districtactive from '@/admin/assets/svg/districtActive.svg';
import schoolActive from '@/admin/assets/svg/schoolsActive.svg';
import dealsDefualt from '@/admin/assets/svg/dealsDefualt.svg';
import historyActive from '@/admin/assets/svg/historyActive.svg';
import settings from '@/admin/assets/svg/settings.svg';
import optionsButton from '@/admin/assets/svg/optionsButton.svg';
import classes from '@/admin/assets/svg/classes.svg';
import classActive from '@/admin/assets/svg/classActive.svg';
import downloadIcon from '@/admin/assets/svg/download2.svg';

import en from '@/admin/assets/svg/langs/en.svg';
import he from '@/admin/assets/svg/langs/he.svg';
import pt from '@/admin/assets/svg/langs/pt.svg';
import es from '@/admin/assets/svg/langs/es.svg';

import user from '@/admin/assets/svg/user.svg';
import lock from '@/admin/assets/svg/lock.svg';
import logOut from '@/admin/assets/svg/logOut.svg';
import settingUser from '@/admin/assets/svg/settingUser.svg';
import world2 from '@/admin/assets/svg/world2.svg';
import helpBtn from '@/admin/assets/svg/helpBtn.svg';
import questionMark from '@/admin/assets/svg/questionMark.svg';
import refresh from '@/admin/assets/svg/refresh-start.svg';
import copy from '@/admin/assets/svg/copy.svg';
import clock from '@/admin/assets/svg/clock.svg';
import error from '@/admin/assets/svg/error.svg';
import progress from '@/admin/assets/svg/activities-completed.svg';
import chat from '@/admin/assets/svg/chat.svg';
import dropdownLogout from '@/admin/assets/svg/dropdown-logout.svg';
import dropdownSettings from '@/admin/assets/svg/dropdown-settings.svg';
import dropdownContact from '@/admin/assets/svg/dropdown-contact.svg';
import dropdownGuides from '@/admin/assets/svg/dropdown-guides.svg';
import expand from '@/admin/assets/svg/expand.svg';

import failureRate from '@/admin/assets/svg/failure-rate.svg';
import passRate from '@/admin/assets/svg/pass-rate.svg';
import privacyPolicy from '@/admin/assets/svg/privacyPolicy.svg';
import blankLink from '@/admin/assets/svg/blankLink.svg';

export const icons = {
  path,
  pathActive,
  dropDown,
  dropDownV,
  dropDownBlueV,
  VIcon,
  Search,
  ArrowLeft,
  separator,
  toggleOn,
  toggleOff,
  logo,
  portuguese,
  date,
  leftArrow,
  arrowRight,
  filter,
  arrowUp,
  arrowDown,
  userAvatar,
  logoIcon,
  districts,
  schools,
  history,
  userManagement,
  deals,
  x,
  close,
  arrowUpActive,
  arrowDownActive,
  pencil,
  deleteIcon,
  checkCircle,
  cloudUpload,
  download,
  whiteV,
  classReport,
  diamond,
  star,
  avg,
  Districtactive,
  schoolActive,
  dealsDefualt,
  historyActive,
  settings,
  optionsButton,
  classes,
  classActive,
  downloadIcon,
  en,
  he,
  pt,
  es,
  user,
  lock,
  logOut,
  settingUser,
  world2,
  helpBtn,
  questionMark,
  refresh,
  copy,
  clock,
  error,
  progress,
  chat,
  dropdownLogout,
  dropdownSettings,
  dropdownContact,
  dropdownGuides,
  expand,
  failureRate,
  passRate,
  privacyPolicy,
  blankLink,
};
